import * as types from '../types';

const initialState = {
  data: [],
  options: [],
  pagination: {
    rowCount: 0
  },
  paginationSettings: {
    page: 1,
    perPage: 10,
    sort: 'id',
    sortDirection: 'ascending'
  }
};

export const TagsReducers = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FETCH_TAGS_SUCCESS:
      return {
        ...state,
        data: action.data,
        pagination: action.pagination,
        paginationSettings: action.paginationSettings
      };

    case types.FETCH_TAGS_OPTIONS_SUCCESS:
      return {
        ...state,
        options: action.options
      };

    default:
      return state;
  }
};

export const getTagsData = state => state.tags.data;
export const getTagsOptions = state => state.tags.options;
export const getTagsPagination = state => state.tags.pagination;
export const getTagsPaginationSettings = state => state.tags.paginationSettings;
